import jsCookie from 'js-cookie';

jsCookie.defaults.path = '/';
if (window.location.hostname !== 'localhost') {
  jsCookie.defaults.domain = '.sendgrid.com';
}

export const setCookie = (cookieName, value) => jsCookie.set(cookieName, value);

export const removeCookie = cookieName => jsCookie.remove(cookieName);

export const getParsedCookie = cookieName => jsCookie.getJSON(cookieName);

export const getCookie = cookieName => jsCookie.get(cookieName);
